export default "__VITE_ASSET__AyBS04BW__"